"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Currency = require("../../../records/Currency");
function resolveCurrency(all, available, candidate) {
  var _all$candidate, _all$candidate$fallba;
  if (available[candidate] != null) {
    return available[candidate];
  }
  const fallback = (_all$candidate = all[candidate]) === null || _all$candidate === void 0 ? void 0 : (_all$candidate$fallba = _all$candidate.fallback) === null || _all$candidate$fallba === void 0 ? void 0 : _all$candidate$fallba.id;
  if (fallback != null && available[fallback] != null) {
    return available[fallback];
  }
  if (available[_Currency.currencyDefault.id] != null) {
    return available[_Currency.currencyDefault.id];
  }
  return available[Object.keys(available).sort()[0]];
}
var _default = resolveCurrency;
exports.default = _default;